import { BASE_URL, getAuthBaseUrl } from './environment';

// Centralized API configuration for backend server URLs
export const API_CONFIG = {
  // Base URL for backend server
  BASE_URL: BASE_URL,

  // File download base URL
  FILE_BASE_URL: BASE_URL,

  // Authentication base URL
  AUTH_BASE_URL: getAuthBaseUrl(),

  // API endpoints
  ENDPOINTS: {
    // Auth endpoints
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    REFRESH_TOKEN: '/api/auth/refresh',
    CURRENT_USER: '/api/currentUser',

    // User management endpoints
    USERS: '/api/users',
    ROLES: '/api/roles',

    // Face recognition endpoints
    FACE_RECOGNITION: {
      USER_FACES: (userId: string) => `/api/face-recognition/users/${userId}/faces`,
      FACE_DATA: (faceId: string) => `/api/face-recognition/faces/${faceId}`,
      RECOGNIZE: '/api/face-recognition/recognize',
      STATS: '/api/face-recognition/stats',
    },

    // One-time password endpoints
    ONE_TIME_PASSWORD: {
      CREATE: '/api/one-time-tokens',
      LIST: '/api/one-time-tokens',
      UPDATE: (tokenId: string) => `/api/one-time-tokens/${tokenId}`,
    },

    // OCR endpoints
    OCR: {
      TABLE_OCR: '/api/ocr/table_ocr',
    },
  },

  // Request configuration
  REQUEST_CONFIG: {
    TIMEOUT: 30000, // 30 seconds
    RETRY_TIMES: 3,
    RETRY_DELAY: 1000, // 1 second
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get full file download URL
export const getFileUrl = (endpoint: string): string => {
  return `${API_CONFIG.FILE_BASE_URL}${endpoint}`;
};

// Helper function to get full authentication URL
export const getAuthUrl = (endpoint: string): string => {
  return `${API_CONFIG.AUTH_BASE_URL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = (contentType?: string) => {
  const token = localStorage.getItem('access_token');
  const headers: Record<string, string> = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  return headers;
};
